module.exports = __webpack_public_path__ + "img/grace-la-margna.836d51de.jpg";